<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';

const account = useAccount();
const globalConfig = useMapGetter('globalConfig/get');

const termsUrl = computed(() => globalConfig.value?.termsURL || '/lais/termos');
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="flex h-full flex-col overflow-hidden bg-[#fcfaf6]">
    <LaisHeader
      title="Termos de uso"
      helper="Resumo dos termos e links legais que sustentam a experiência autenticada da Imudei."
    />

    <div class="flex-1 overflow-auto px-4 py-4 sm:px-6 lg:px-10 lg:py-6">
      <div
        class="grid gap-5 xl:grid-cols-[minmax(0,1.1fr)_minmax(320px,0.9fr)]"
      >
        <div class="grid gap-5">
          <LaisCard title="O que este app cobre">
            <ul class="space-y-3 text-[13px] leading-6 text-lais-text-muted">
              <li>
                A experiência autenticada concentra atendimento, clientes,
                imóveis, visitas, relatórios e configurações comerciais da
                conta.
              </li>
              <li>
                O uso do sistema pressupõe respeito às permissões do seu perfil,
                às regras da conta ativa e aos fluxos operacionais definidos em
                <strong class="text-lais-text">Minha Imudei</strong>.
              </li>
              <li>
                Recursos legais públicos mais extensos, como política completa,
                suporte e termos complementares, continuam disponíveis quando
                você precisar.
              </li>
            </ul>
          </LaisCard>

          <LaisCard title="Links relacionados dentro do app">
            <div class="grid gap-3 md:grid-cols-2">
              <RouterLink
                :to="account.accountScopedRoute('privacidade_index')"
                class="rounded-lais border border-lais-border bg-white px-4 py-3 transition-all hover:border-lais-primary hover:shadow-lais-soft"
              >
                <p class="text-[14px] font-semibold text-lais-text">
                  Privacidade
                </p>
                <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
                  Veja como o tratamento de dados se conecta às regras do app.
                </p>
              </RouterLink>

              <RouterLink
                :to="account.accountScopedRoute('manual_usuario_index')"
                class="rounded-lais border border-lais-border bg-white px-4 py-3 transition-all hover:border-lais-primary hover:shadow-lais-soft"
              >
                <p class="text-[14px] font-semibold text-lais-text">
                  Manual do usuário
                </p>
                <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
                  Entenda onde cada rotina operacional está localizada.
                </p>
              </RouterLink>
            </div>
          </LaisCard>
        </div>

        <div class="grid gap-5">
          <LaisCard title="Documento completo">
            <div class="space-y-3 text-[13px] leading-6 text-lais-text-muted">
              <p>
                Este resumo existe para reduzir atrito dentro do app, mas o
                texto legal completo continua sendo a referência oficial.
              </p>
              <a
                :href="termsUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="inline-flex items-center gap-2 rounded-lais border border-lais-border bg-white px-3 py-2 font-semibold text-lais-text transition-all hover:border-lais-primary hover:text-lais-link"
              >
                <span class="i-lucide-external-link size-4" />
                Abrir termos completos
              </a>
            </div>
          </LaisCard>
        </div>
      </div>
    </div>
  </section>
</template>
